import React from 'react';
import Reflux from 'reflux';
import classnames from 'classnames';
import Tag from 'shared/components/tag/tag';
import { OrderedMap, List } from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import AddTagMenu from 'shared/components/tag/addTagMenu';

const defaultPopoverId = 'hiddenTagsList';

export default React.createClass({
  mixins: [PureRenderMixin, Reflux.connect(PopoverStore, 'popoverVisibility')],

  displayName: 'TagList',

  propTypes: {
    popoverId: React.PropTypes.string,
    popoverTitle: React.PropTypes.string,
    popoverClasses: React.PropTypes.string,
    placement: React.PropTypes.string,
    tags: React.PropTypes.object,
    width: React.PropTypes.number,
    disableHiddenTagsPopover: React.PropTypes.bool,
    onHiddenClick: React.PropTypes.func,
    onRemove: React.PropTypes.func,
    tagFilters: React.PropTypes.object,
    isFilter: React.PropTypes.bool,
    onFilterChange: React.PropTypes.func,
    disableFilterSorting: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
      popoverId: defaultPopoverId,
      tags: OrderedMap(),
    };
  },

  getInitialState() {
    return {
      tagWidths: {},
    };
  },

  componentDidMount() {
    const { tags } = this.props;
    if (tags && tags.size > 0) this._calculateTagWidths(tags);
  },

  componentWillReceiveProps(nextProps) {
    const { tags } = this.props;

    if (nextProps.tags && nextProps.tags.size > 0 && nextProps.tags !== tags)
      this._calculateTagWidths(nextProps.tags);
  },

  render() {
    const { tags } = this.props;
    // const { popoverId, wrapperClasses } = this.props;
    // const { popoverVisibility } = this.state;

    if (!tags) return null;

    return <div className="tag-list">{this._getTagDisplayNodes(tags)}</div>;
  },

  _getTagDisplayNodes(tags) {
    const { width, onRemove } = this.props;
    const { tagWidths } = this.state;

    const tagNodes = [];

    const hiddenTagsNodeWidth = 20;
    let availableWidth = width - hiddenTagsNodeWidth;
    let hiddenTags = 0;

    tags.forEach((tag, tagId) => {
      const tagWidth = tagWidths[tagId] || 0;
      const padding = 2;
      availableWidth -= tagWidth + padding;

      if (availableWidth > 0) {
        tagNodes.push(
          <Tag
            id={tag.get('_id')}
            key={tag.get('_id')}
            text={tag.get('text')}
            color={tag.get('color')}
            removeIcon="times"
            onRemove={onRemove}
          />,
        );
      } else {
        hiddenTags += 1;
      }
    });

    if (hiddenTags > 0) {
      const labelCountNode = (
        <span className="tag-list__hidden-tags">+ {hiddenTags}</span>
      );

      const hiddenTagsNode = this._getHiddenTagsPopover(labelCountNode);

      tagNodes.push(hiddenTagsNode);
    }

    return tagNodes;
  },

  _getHiddenTagsPopover(displayNode) {
    const {
      popoverId,
      popoverTitle,
      popoverClasses,
      tags,
      isFilter,
      onFilterChange,
      tagFilters,
      disableFilterSorting,
    } = this.props;
    // const { popoverVisibility } = this.state;

    let activeTagIds = List();
    tags.forEach((tag, tagId) => {
      activeTagIds = activeTagIds.push(tagId);
    });

    return (
      <span key="hidden-tags">
        <AddTagMenu
          popoverTitle={popoverTitle}
          displayNode={displayNode}
          tags={tagFilters}
          activeTagIds={activeTagIds}
          popoverClasses={classnames('tag-list__popover', popoverClasses)}
          placement="bottom"
          popoverId={popoverId}
          isFilter={isFilter}
          disableSearch={!isFilter}
          disableSelection={!isFilter}
          disableCreateEdit
          disableSorting={disableFilterSorting}
          displayClear={isFilter}
          clearText="Clear all filters"
          onChange={onFilterChange}
        />
      </span>
    );
  },

  _calculateTagWidths(tags) {
    const { onRemove } = this.props;

    const tagWidths = {};

    const parentElem = document.createElement('div');
    parentElem.style.left = '100px';
    parentElem.className = 'tag-list';

    document.body.appendChild(parentElem);

    tags.forEach((tag, tagId) => {
      const childElem = document.createElement('div');
      const removalHtml = onRemove
        ? `<span name="times" class="fa fa-times"></span>`
        : '';

      childElem.innerHTML = `<div class="label label-default">
          <span class="tag-text">${tag.get('text')}</span>
          ${removalHtml}
        </div>`;

      parentElem.appendChild(childElem);

      tagWidths[tagId] = childElem.childNodes[0].offsetWidth;
    });

    document.body.removeChild(parentElem);

    this.setState({ tagWidths });
  },
});
